import React from "react";
import { newProfilePersonalInfoApplicationPath } from "../../../../../../routes";
import WandStarsIcon from "../../icons/WandStarsIcon";

import Button from "../../ui/Button";

import { Box, HStack, Link, Text } from "@chakra-ui/react";

export const DrawerArchitectApplicationPendingPrompt = () => (
  <Box backgroundColor="brand.50" px={5} py={4}>
    <HStack gap={3} align="center">
      <WandStarsIcon boxSize={6} color="primary" flexShrink={0} />
      <Text fontSize="xs">
        建築士登録を行うことで、Q&Aの投稿・解答閲覧や、勉強会動画の視聴など様々な機能が利用可能になります。
      </Text>
    </HStack>
    <Button mt={4} w="full" size="sm" as={Link} textDecoration="none" href={newProfilePersonalInfoApplicationPath()}>
      登録審査状況を確認する
    </Button>
  </Box>
);
